import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import ScrollReveal from "scrollreveal";
import {
  Navbar,
  Header,
  About,
  Skills,
  ProjectsSection,
  ProjectsPage,
  Banner,
  Contact,
} from "../index";
import SingleProject from "../projects-page/SingleProject";

export default function Layout() {
  /* useEffect(() => {
    const sr = ScrollReveal({
      duration: 2800,
      reset: true,
    });
    sr.reveal(
      `
      
      `,
      {
        opacity: 0,
        interval: 300,
      }
    );
  }, []);*/

  return (
    <BrowserRouter>
      <div className="bg-light">
        <Navbar />
      </div>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id/:title" element={<SingleProject />} />
      </Routes>
      <Contact />
    </BrowserRouter>
  );
}

const Landing = () => {
  return (
    <>
      <div className="bg-light">
        <Header />
      </div>
      <About />
      <Skills />
      <ProjectsSection />
      <div className="bg-light">
        <Banner />
      </div>
    </>
  );
};
